// // import React, { useState, useEffect, useRef, Fragment } from "react";
// // import { Grid, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
// // import {Straighten as RulerIcon, SquareFoot as SquareFootIcon} from "@mui/icons-material";

// // import NavigateToPark from "./NavigateToPark";
// // import DefaultMap from "./DefaultMap";
// // import MapDataProvider from "../MapData/MapDataProvider";
// // import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";

// // import { DEFAULT_CENTER } from "../Util/Util";

// // import GetControls from "./ShowControlsAndInteractions/GetControls";
// // import GetInteractions from "./ShowControlsAndInteractions/GetInteractions";

// // import { Vector as VectorSource } from "ol/source";
// // import { VectorLayer } from "../Layers";
// // import { DrawInteraction } from "../Interactions";

// // import { getNonParcelFeatureStyle } from "../Style/NonParcelStyler";

// // //prettier-ignore
// // const ViewMap = ({ isSelectable = true, isEditable = false, showLegend = true, showPopup = true,
// //   additionalLayers = [], additionalInteraction, setSelectedFeatureOnMap, showSateliteImage = true, cent= DEFAULT_CENTER}, highlightParcel= null) => {
// //   const [center, setCenter] = useState();
  
// //   console.log("CENTER on mapview:",cent)
// //   const [selectedFeature, setSelectedFeature] = useState(null);

// //   const [dialogKey, setDialogKey] = useState(0);
// //   const previousFeatureIdRef = useRef(null);
// //   const [measurement, setMeasurement] = useState({ value: 0, unitOfMeasure: null }); // Change type to unitOfMeasure
// //   const [drawType, setDrawType] = useState(null);
// //   const [isDrawing, setIsDrawing] = useState(false);

// //   const [measurementSource] = useState(new VectorSource());
  
// //   useEffect(() => {
    
// //     const currentFeatureId = selectedFeature?.[0]?.getId();
    
// //     if (currentFeatureId !== previousFeatureIdRef.current) {
// //       setDialogKey(prevKey => prevKey + 1);
// //       previousFeatureIdRef.current = currentFeatureId;
// //     }
// //     if (selectedFeature && setSelectedFeatureOnMap) setSelectedFeatureOnMap(selectedFeature);
// //     setCenter(cent)
// //   }, [cent]);

// //   const controls = <GetControls showLegend={showLegend} />;

// //   const measureCallback = (measurement, type) => {
// //     setMeasurement({
// //       value: measurement,
// //       unitOfMeasure: type === "LineString" ? "m" : "m²",
// //     });
// //   };

// //   const interactions = (
// //     <GetInteractions
// //       isSelectable={isSelectable}
// //       isEditable={isEditable}
// //       setSelectedFeature={setSelectedFeature}
// //       showPopup={showPopup}
// //       additionalInteraction={
// //         <>
// //           {additionalInteraction}
// //           {drawType && (
// //             <DrawInteraction
// //               source={measurementSource}
// //               type={drawType}
// //               onMeasurement={measureCallback}
// //               setDrawType={setDrawType}
// //               setIsDrawing={isDrawing => setIsDrawing(isDrawing)}
// //             />
// //           )}
// //         </>
// //       }
// //     />
// //   );

// //   const handleMeasurementTypeChange = (event, newType) => {
// //     setDrawType(newType);
// //     setMeasurement({ value: 0, unitOfMeasure: null });
// //   };
// //   const safeAdditionalLayers = Array.isArray(additionalLayers) ? additionalLayers : [additionalLayers];

// //   return (
// //     <>
// //       <MapDataProvider>
// //         {console.log(" ViewMap AAAAAAAAAAAAAAAAAAA:",highlightParcel)}
// //         <Grid container sx={{ alignContent: "center", alignItems: "center" }}>
// //           <Grid item xs={4}>
// //             <NavigateToPark center={center} setCenter={setCenter} />
// //           </Grid>
// //           <Grid item xs={2} sx={{ px: 2 }}>
// //             <ToggleButtonGroup exclusive onChange={handleMeasurementTypeChange} value={drawType}>
// //               <Tooltip title="Measure Length (Use right click)">
// //                 <ToggleButton value="LineString">
// //                   <RulerIcon />
// //                 </ToggleButton>
// //               </Tooltip>
// //               <Tooltip title="Measure Area (Use right click)">
// //                 <ToggleButton value="Polygon">
// //                   <SquareFootIcon />
// //                 </ToggleButton>
// //               </Tooltip>
// //             </ToggleButtonGroup>
// //           </Grid>
// //           <Grid item xs={2}>
// //             {measurement.value !== 0 && (
// //               <Typography align="left">
// //                 {`${measurement.value.toFixed(2)} ${measurement.unitOfMeasure === "m" ? "m" : "m²"}`}
// //               </Typography>
// //             )}
// //           </Grid>
// //         </Grid>

// //         <DefaultMap
// //           controls={controls}
// //           interactions={interactions}
// //           additionalLayers={[
// //             ...safeAdditionalLayers,
// //             <Fragment key="measurementSource">
// //               <VectorLayer
// //                 zIndex={1000}
// //                 source={measurementSource}
// //                 style={feature =>
// //                   getNonParcelFeatureStyle(feature, "red", true, "measurement", "white", 0.75, "black", 4)
// //                 }
// //               />
// //             </Fragment>,
// //           ]} // Add measurementSource to layers
// //           center={center}
// //           showPark={true}
// //           showBlocks={true}
// //           showParcels={true}
// //           showBuildings={true}
// //           showSheds={true}
// //           showRoads={true}
// //           showGreenAreas={true}
// //           isEditable={isEditable}
// //           showSateliteImage={showSateliteImage}
// //           showCoordinate={true}
// //           highlightParcel = {highlightParcel}

// //         />

// //         {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
// //           <ShowSpatialFeatureDialog
// //             key={dialogKey}
// //             spatialInfo={selectedFeature[0]?.getProperties()}
// //             setShowWhenReady={true}
// //           />
// //         )}
// //       </MapDataProvider>
// //     </>
// //   );
// // };

// // export default React.memo(ViewMap);

// // // ##########################

// import React, { useState, useEffect, useRef, Fragment } from "react";
// import { Grid, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
// import {Straighten as RulerIcon, SquareFoot as SquareFootIcon} from "@mui/icons-material";

// import NavigateToPark from "./NavigateToPark";
// import DefaultMap from "./DefaultMap";
// import MapDataProvider from "../MapData/MapDataProvider";
// import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";

// import { DEFAULT_CENTER } from "../Util/Util";

// import GetControls from "./ShowControlsAndInteractions/GetControls";
// import GetInteractions from "./ShowControlsAndInteractions/GetInteractions";

// import { Vector as VectorSource } from "ol/source";
// import { VectorLayer } from "../Layers";
// import { DrawInteraction } from "../Interactions";

// import { getNonParcelFeatureStyle } from "../Style/NonParcelStyler";

// //prettier-ignore
// const ViewMap = ({ 
//   isSelectable = true, 
//   isEditable = false, 
//   showLegend = true, 
//   showPopup = true,
//   additionalLayers = [], 
//   additionalInteraction, 
//   setSelectedFeatureOnMap, 
//   showSateliteImage = true, 
//   cent = DEFAULT_CENTER,
//   highlightParcel = null  // Add highlightParcel to props destructuring
// }) => {
//   const [center, setCenter] = useState();
  
//   console.log("CENTER on mapview:", cent);
//   console.log("🎯 HIGHLIGHT PARCEL PROP:", highlightParcel); // Add this console log
  
//   const [selectedFeature, setSelectedFeature] = useState(null);
//   const [dialogKey, setDialogKey] = useState(0);
//   const previousFeatureIdRef = useRef(null);
//   const [measurement, setMeasurement] = useState({ value: 0, unitOfMeasure: null });
//   const [drawType, setDrawType] = useState(null);
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [measurementSource] = useState(new VectorSource());
  
//   // Add useEffect to track highlightParcel changes
//   useEffect(() => {
//     console.log("🔄 highlightParcel updated:", highlightParcel);
//   }, [highlightParcel]);

//   useEffect(() => {
//     const currentFeatureId = selectedFeature?.[0]?.getId();
    
//     if (currentFeatureId !== previousFeatureIdRef.current) {
//       setDialogKey(prevKey => prevKey + 1);
//       previousFeatureIdRef.current = currentFeatureId;
//     }
//     if (selectedFeature && setSelectedFeatureOnMap) setSelectedFeatureOnMap(selectedFeature);
//     setCenter(cent);
//   }, [cent, selectedFeature, setSelectedFeatureOnMap]);

//   const controls = <GetControls showLegend={showLegend} />;

//   const measureCallback = (measurement, type) => {
//     setMeasurement({
//       value: measurement,
//       unitOfMeasure: type === "LineString" ? "m" : "m²",
//     });
//   };

//   const interactions = (
//     <GetInteractions
//       isSelectable={isSelectable}
//       isEditable={isEditable}
//       setSelectedFeature={setSelectedFeature}
//       showPopup={showPopup}
//       additionalInteraction={
//         <>
//           {additionalInteraction}
//           {drawType && (
//             <DrawInteraction
//               source={measurementSource}
//               type={drawType}
//               onMeasurement={measureCallback}
//               setDrawType={setDrawType}
//               setIsDrawing={isDrawing => setIsDrawing(isDrawing)}
//             />
//           )}
//         </>
//       }
//     />
//   );

//   const handleMeasurementTypeChange = (event, newType) => {
//     setDrawType(newType);
//     setMeasurement({ value: 0, unitOfMeasure: null });
//   };
  
//   const safeAdditionalLayers = Array.isArray(additionalLayers) ? additionalLayers : [additionalLayers];

//   return (
//     <>
//       <MapDataProvider>
//         {console.log("🎯 ViewMap highlightParcel in render:", highlightParcel)} {/* Keep this for render tracking */}
        
//         <Grid container sx={{ alignContent: "center", alignItems: "center" }}>
//           <Grid item xs={4}>
//             <NavigateToPark center={center} setCenter={setCenter} />
//           </Grid>
//           <Grid item xs={2} sx={{ px: 2 }}>
//             <ToggleButtonGroup exclusive onChange={handleMeasurementTypeChange} value={drawType}>
//               <Tooltip title="Measure Length (Use right click)">
//                 <ToggleButton value="LineString">
//                   <RulerIcon />
//                 </ToggleButton>
//               </Tooltip>
//               <Tooltip title="Measure Area (Use right click)">
//                 <ToggleButton value="Polygon">
//                   <SquareFootIcon />
//                 </ToggleButton>
//               </Tooltip>
//             </ToggleButtonGroup>
//           </Grid>
//           <Grid item xs={2}>
//             {measurement.value !== 0 && (
//               <Typography align="left">
//                 {`${measurement.value.toFixed(2)} ${measurement.unitOfMeasure === "m" ? "m" : "m²"}`}
//               </Typography>
//             )}
//           </Grid>
//         </Grid>

//         <DefaultMap
//           controls={controls}
//           interactions={interactions}
//           additionalLayers={[
//             ...safeAdditionalLayers,
//             <Fragment key="measurementSource">
//               <VectorLayer
//                 zIndex={1000}
//                 source={measurementSource}
//                 style={feature =>
//                   getNonParcelFeatureStyle(feature, "red", true, "measurement", "white", 0.75, "black", 4)
//                 }
//               />
//             </Fragment>,
//           ]}
//           center={center}
//           showPark={true}
//           showBlocks={true}
//           showParcels={true}
//           showBuildings={true}
//           showSheds={true}
//           showRoads={true}
//           showGreenAreas={true}
//           isEditable={isEditable}
//           showSateliteImage={showSateliteImage}
//           showCoordinate={true}
//           highlightParcel={highlightParcel} // Pass the prop to DefaultMap
//         />

//         {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
//           <ShowSpatialFeatureDialog
//             key={dialogKey}
//             spatialInfo={selectedFeature[0]?.getProperties()}
//             setShowWhenReady={true}
//           />
//         )}
//       </MapDataProvider>
//     </>
//   );
// };

// export default React.memo(ViewMap);

// // // #########################

import React, { useState, useEffect, useRef, Fragment, useCallback, useMemo } from "react";
import { Grid, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import {Straighten as RulerIcon, SquareFoot as SquareFootIcon} from "@mui/icons-material";

import NavigateToPark from "./NavigateToPark";
import DefaultMap from "./DefaultMap";
import MapDataProvider from "../MapData/MapDataProvider";
import ShowSpatialFeatureDialog from "../ShowSpatialFeatureDialog";

import { DEFAULT_CENTER } from "../Util/Util";

import GetControls from "./ShowControlsAndInteractions/GetControls";
import GetInteractions from "./ShowControlsAndInteractions/GetInteractions";

import { Vector as VectorSource } from "ol/source";
import { VectorLayer } from "../Layers";
import { DrawInteraction } from "../Interactions";

import { getNonParcelFeatureStyle } from "../Style/NonParcelStyler";

const ViewMap = ({ 
  isSelectable = true, 
  isEditable = false, 
  showLegend = true, 
  showPopup = true,
  additionalLayers = [], 
  additionalInteraction, 
  setSelectedFeatureOnMap, 
  showSateliteImage = true, 
  cent = DEFAULT_CENTER,
  highlightParcel = null
}) => {
  // ===== MAP VIEW STATE =====
  // This ONLY changes via NavigateToPark component
  const [center, setCenter] = useState(cent);
  
  // ===== SELECTION STATE =====
  // This changes when user clicks on features - DOES NOT affect map view
  const [selectedFeature, setSelectedFeature] = useState(null);

  // ===== UI STATE =====
  const [dialogKey, setDialogKey] = useState(0);
  const previousFeatureIdRef = useRef(null);
  const [measurement, setMeasurement] = useState({ value: 0, unitOfMeasure: null });
  const [drawType, setDrawType] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [measurementSource] = useState(new VectorSource());
  
  // Use ref to track initial load
  const initialLoadDoneRef = useRef(false);

  // Update dialog when selected feature changes
  useEffect(() => {
    const currentFeatureId = selectedFeature?.[0]?.getId();
    
    if (currentFeatureId !== previousFeatureIdRef.current) {
      setDialogKey(prevKey => prevKey + 1);
      previousFeatureIdRef.current = currentFeatureId;
    }
    if (selectedFeature && setSelectedFeatureOnMap) {
      setSelectedFeatureOnMap(selectedFeature);
    }
  }, [selectedFeature, setSelectedFeatureOnMap]);

  // Set initial center from prop (ONLY ONCE)
  useEffect(() => {
    if (!initialLoadDoneRef.current && cent) {
      console.log("Setting initial center:", cent);
      setCenter(cent);
      initialLoadDoneRef.current = true;
    }
  }, [cent]);

  // Handle center change from NavigateToPark
  const handleCenterChange = useCallback((newCenter) => {
    console.log("Center changed via navigation:", newCenter);
    setCenter(newCenter);
  }, []);

  // Memoize controls and interactions
  const controls = useMemo(() => <GetControls showLegend={showLegend} />, [showLegend]);

  const measureCallback = useCallback((measurement, type) => {
    setMeasurement({
      value: measurement,
      unitOfMeasure: type === "LineString" ? "m" : "m²",
    });
  }, []);

  const interactions = useMemo(() => (
    <GetInteractions
      isSelectable={isSelectable}
      isEditable={isEditable}
      setSelectedFeature={setSelectedFeature}
      showPopup={showPopup}
      additionalInteraction={
        <>
          {additionalInteraction}
          {drawType && (
            <DrawInteraction
              source={measurementSource}
              type={drawType}
              onMeasurement={measureCallback}
              setDrawType={setDrawType}
              setIsDrawing={isDrawing => setIsDrawing(isDrawing)}
            />
          )}
        </>
      }
    />
  ), [isSelectable, isEditable, showPopup, additionalInteraction, drawType, measureCallback, measurementSource]);

  const handleMeasurementTypeChange = useCallback((event, newType) => {
    setDrawType(newType);
    setMeasurement({ value: 0, unitOfMeasure: null });
  }, []);
  
  const safeAdditionalLayers = useMemo(() => 
    Array.isArray(additionalLayers) ? additionalLayers : [additionalLayers],
  [additionalLayers]);

  return (
    <>
      <MapDataProvider>
        <Grid container sx={{ alignContent: "center", alignItems: "center" }}>
          <Grid item xs={4}>
            <NavigateToPark center={center} setCenter={handleCenterChange} />
          </Grid>
          <Grid item xs={2} sx={{ px: 2 }}>
            <ToggleButtonGroup exclusive onChange={handleMeasurementTypeChange} value={drawType}>
              <Tooltip title="Measure Length (Use right click)">
                <ToggleButton value="LineString">
                  <RulerIcon />
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Measure Area (Use right click)">
                <ToggleButton value="Polygon">
                  <SquareFootIcon />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={2}>
            {measurement.value !== 0 && (
              <Typography align="left">
                {`${measurement.value.toFixed(2)} ${measurement.unitOfMeasure === "m" ? "m" : "m²"}`}
              </Typography>
            )}
          </Grid>
        </Grid>

        <DefaultMap
          controls={controls}
          interactions={interactions}
          additionalLayers={[
            ...safeAdditionalLayers,
            <Fragment key="measurementSource">
              <VectorLayer
                zIndex={1000}
                source={measurementSource}
                style={feature =>
                  getNonParcelFeatureStyle(feature, "red", true, "measurement", "white", 0.75, "black", 4)
                }
              />
            </Fragment>,
          ]}
          center={center}  // This ONLY changes via NavigateToPark
          showPark={true}
          showBlocks={true}
          showParcels={true}
          showBuildings={true}
          showSheds={true}
          showRoads={true}
          showGreenAreas={true}
          isEditable={isEditable}
          showSateliteImage={showSateliteImage}
          showCoordinate={true}
          highlightParcel={highlightParcel}
          // selectedFeature is NOT passed to map props
        />

        {showPopup && selectedFeature && selectedFeature[0]?.getId() && (
          <ShowSpatialFeatureDialog
            key={dialogKey}
            spatialInfo={selectedFeature[0]?.getProperties()}
            setShowWhenReady={true}
          />
        )}
      </MapDataProvider>
    </>
  );
};

export default React.memo(ViewMap);

